export default "__VITE_ASSET__PmWkUimu__"